import {
  AsyncComponentProps,
  WorkflowDefaultStepBlock,
  WorkflowStepFormFieldBlock,
} from '~/core/shared/types';

export const isFormFieldBlockWithAsyncComponentProps = (
  block: WorkflowDefaultStepBlock,
): block is WorkflowStepFormFieldBlock & {
  asyncComponentProps: AsyncComponentProps;
} => block.type === 'form-field' && !!block.asyncComponentProps?.asyncData;
